import { ValidationError } from "sequelize"
import {
    OkrSession,
    OkrSessionCreate,
    OkrSessionSave,
} from "server/models"

import { ARCHIVED, IN_PROGRESS } from "const"
import { GET, POST, DELETE, validate } from "client/store/utils"
import {
    LangType,
    OkrSessionList,
    OkrSessionValidation,
    OkrSessionFilters,
} from "client/store"

export const LoadAllOkrSessions = (accountId: number) => (
    GET(`/okrSession/accountId/${accountId}`)
    .then((sessions: OkrSession[]) => {
        const sessionList: OkrSessionList = {}
        sessions.forEach((session) => {
            sessionList[session.id] = session
        })
        return sessionList
    })
)

export const LoadOkrSessionById = (sessionId: number, accountId: number) => (
    GET(`/okrSession/id/${sessionId}/accountId/${accountId}`)
    .then((session: OkrSession) => session)
)

export const SaveOkrSession = (
    id: number,
    session: OkrSessionCreate,
    lang: LangType,
) => {
    const data: OkrSessionSave = {
        id,
        session,
    }
    return POST(
        "/okrSession/save",
        JSON.stringify(data),
    ).then((res) => {
        const newSession = res as OkrSession
        const error = res as ValidationError

        return {
            newSessionId: newSession.id || null,
            validation: <OkrSessionValidation>validate(error, lang),
        }
    })
}

export const ClearParentsOkrSession = (sessionId: number, accountId: number) => (
    GET(`/okrSession/clearParents/sessionId/${sessionId}/accountId/${accountId}`)
)

export const DeleteOkrSession = (sessionId: number, accountId: number) => (
    DELETE(`/okrSession/delete/${sessionId}/${accountId}`)
    .then((removedRows: number) => removedRows)
)

export const SortOkrSessions = (
    sessions: OkrSession[],
    filters: OkrSessionFilters,
) => {
    const sessionsFiltered = sessions.filter((session) => {
        let showRow = true
        if (!filters.showArchived && session.status === ARCHIVED) showRow = false
        if (!filters.showInProgress && session.status === IN_PROGRESS) showRow = false
        if (filters.search && session.name.toUpperCase().indexOf(filters.search.trim().toUpperCase()) < 0) showRow = false
        return showRow
    })

    sessionsFiltered.sort((a, b) => {
        const dateEndA = new Date(a.dateEnd)
        const dateEndB = new Date(b.dateEnd)

        let res = 0
        if (dateEndA > dateEndB) res = -1
        else if (dateEndA < dateEndB) res = 1
        return res
    })

    return sessionsFiltered
}
